import { render, staticRenderFns } from "./PersonSimple.vue?vue&type=template&id=32114144&"
import script from "./PersonSimple.vue?vue&type=script&lang=js&"
export * from "./PersonSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports